import React from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import { translate } from 'react-i18next';

const DetailFieldText = ({ label, value, t, full = false }) => {
  return (
    <div
      className={classnames(
        {
          'col-sm-6 col-md-4 col-lg-3': !full,
          'col-12': full,
        },
        'mb-2'
      )}
    >
      <div className="form-group row">
        <label className="col-sm-12 col-form-label py-0">
          <b>{t(label)}:</b>
        </label>
        <div className="col-sm-12">
          <p className="form-control-plaintext">{value ? value : '-'}</p>
        </div>
      </div>
    </div>
  );
};

DetailFieldText.propTypes = {
  label: PropTypes.string.isRequired,
  value: PropTypes.string,
  t: PropTypes.func.isRequired,
  full: PropTypes.bool,
};

export default translate()(DetailFieldText);



// WEBPACK FOOTER //
// src/modules/secured/modules/fixedassets/components/detail/field/DetailFieldText.js